import Dispatcher from "../dispatcher";

const FractionStore = {
  _state: {
    openModal: "",
    getData: ""
  },

  // get the state of fraction
  get() {
    return this._state;
  },

  isOpen(modalId) {
    return this._state.openModal === modalId;
  },

  openModal() {
    return this._state.openModal;
  },

  getData() {
    return this._state.getData || {};
  },

  _updateState(state) {
    this._state = $.extend(this._state, state);
    Dispatcher.emit(Dispatcher.MODAL_STORE_CHANGE);
  },

  init() {
    Dispatcher.setMaxListeners(Dispatcher.getMaxListeners() + 12);

    Dispatcher.bind(Dispatcher.OPEN_MODAL, (modalId, data) => {
      this._updateState({ openModal: modalId, getData: data });
    });
    Dispatcher.bind(Dispatcher.CLOSE_MODAL, (modalId, data) => {
      if (modalId) {
        if (this._state.openModal === modalId) {
          this._updateState({ openModal: false, getData: false });
        }
      } else {
        this._updateState({ openModal: false, getData: false });
      }
    });
  }
};

FractionStore.init();

export default FractionStore;
